import axios from "axios";
import { logout } from "../lib/auth";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// 契約情報項目削除
export async function deleteContractContractInfo(id: string, key: string) {
  try {
    const response = await axios.delete(
      CONST.apiUrl + "contractContractInfo" + "?id=" + encodeURIComponent(id) + "&key=" + encodeURIComponent(key)
    );
    return response.data.delete;
  } catch (error) {
    logout();
  }
}

// 契約情報一覧
export async function getContractContractInfos(id: string) {
  try {
    const path = "contractContractInfos";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return { sudDatas: response.data.fetch_data };
  } catch (error) {
    return { sudDatas: [] };
    // logout();
  }
}
